'use strict';
import * as $j_app$002epages$002e$002dDocument$002dTemplates$002dCreate$002dPage$0024$002dArgs$0024$0024anon$00241 from "./app.pages.-Document-Templates-Create-Page$-Args$$anon$1.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
function $s_Lapp_pages_DocumentTemplatesCreatePage$Args$__Standalone__Lapp_pages_DocumentTemplatesCreatePage$Args() {
  $m_Lapp_pages_DocumentTemplatesCreatePage$Args$();
  return $t_Lapp_pages_DocumentTemplatesCreatePage$Args$__Standalone;
}
export { $s_Lapp_pages_DocumentTemplatesCreatePage$Args$__Standalone__Lapp_pages_DocumentTemplatesCreatePage$Args as $s_Lapp_pages_DocumentTemplatesCreatePage$Args$__Standalone__Lapp_pages_DocumentTemplatesCreatePage$Args };
/** @constructor */
function $c_Lapp_pages_DocumentTemplatesCreatePage$Args$() {
  $n_Lapp_pages_DocumentTemplatesCreatePage$Args$ = this;
  $t_Lapp_pages_DocumentTemplatesCreatePage$Args$__Standalone = new $j_app$002epages$002e$002dDocument$002dTemplates$002dCreate$002dPage$0024$002dArgs$0024$0024anon$00241.$c_Lapp_pages_DocumentTemplatesCreatePage$Args$$anon$1("Standalone", 0);
}
export { $c_Lapp_pages_DocumentTemplatesCreatePage$Args$ as $c_Lapp_pages_DocumentTemplatesCreatePage$Args$ };
$p = $c_Lapp_pages_DocumentTemplatesCreatePage$Args$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_DocumentTemplatesCreatePage$Args$;
/** @constructor */
function $h_Lapp_pages_DocumentTemplatesCreatePage$Args$() {
}
export { $h_Lapp_pages_DocumentTemplatesCreatePage$Args$ as $h_Lapp_pages_DocumentTemplatesCreatePage$Args$ };
$h_Lapp_pages_DocumentTemplatesCreatePage$Args$.prototype = $p;
$p.dl = (function(x) {
  return x.co();
});
var $d_Lapp_pages_DocumentTemplatesCreatePage$Args$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_DocumentTemplatesCreatePage$Args$, "app.pages.DocumentTemplatesCreatePage$Args$", ({
  Hs: 1,
  d: 1,
  D: 1
}));
export { $d_Lapp_pages_DocumentTemplatesCreatePage$Args$ as $d_Lapp_pages_DocumentTemplatesCreatePage$Args$ };
var $n_Lapp_pages_DocumentTemplatesCreatePage$Args$;
function $m_Lapp_pages_DocumentTemplatesCreatePage$Args$() {
  if ((!$n_Lapp_pages_DocumentTemplatesCreatePage$Args$)) {
    $n_Lapp_pages_DocumentTemplatesCreatePage$Args$ = new $c_Lapp_pages_DocumentTemplatesCreatePage$Args$();
  }
  return $n_Lapp_pages_DocumentTemplatesCreatePage$Args$;
}
export { $m_Lapp_pages_DocumentTemplatesCreatePage$Args$ as $m_Lapp_pages_DocumentTemplatesCreatePage$Args$ };
var $t_Lapp_pages_DocumentTemplatesCreatePage$Args$__Standalone = null;
function $u_Lapp_pages_DocumentTemplatesCreatePage$Args$__Standalone(x) {
  $t_Lapp_pages_DocumentTemplatesCreatePage$Args$__Standalone = x;
}
export { $t_Lapp_pages_DocumentTemplatesCreatePage$Args$__Standalone as $t_Lapp_pages_DocumentTemplatesCreatePage$Args$__Standalone, $u_Lapp_pages_DocumentTemplatesCreatePage$Args$__Standalone as $u_Lapp_pages_DocumentTemplatesCreatePage$Args$__Standalone };
//# sourceMappingURL=app.pages.-Document-Templates-Create-Page$-Args$.js.map
